export class FormCacheStorageInterface {
    constructor(props = {}) {
        this.name = props.name;

        this._init();
    }

    _init() {
        if (!this.name) {
            throw new Error('FormCacheStorageInterface: Name is not defined!');
        }
    }

    get(key) {}

    set(key, value) {}

    batchSet(data) {}

    delete(key) {}
}

export class FormCacheLocalStorage extends FormCacheStorageInterface {
    constructor(props = {}) {
        super(props);
    }

    _getStorage() {
        let storage = localStorage.getItem(this.name);

        if (storage) {
            return JSON.parse(storage);
        }

        localStorage.setItem(this.name, JSON.stringify({}));
        return {};
    }

    get(key) {
        return this._getStorage()[key];
    }

    set(key, value) {
        let storage = this._getStorage();
        Object.assign(storage, { [key]: value });
        localStorage.setItem(this.name, JSON.stringify(storage));
    }

    batchSet(data) {
        if (!data || typeof data !== 'object') {
            return;
        }

        let storage = this._getStorage();
        Object.assign(storage, data);
        localStorage.setItem(this.name, JSON.stringify(storage));
    }

    delete(key) {
        let storage = this._getStorage();
        delete storage[key];
        localStorage.setItem(this.name, JSON.stringify(storage));
    }

}

export class FormCacheCookieStorage extends FormCacheStorageInterface {
    constructor(props = {}) {
        super(props);

        this.expires = props.expires || 30 * 24 * 60 * 60 // 30 days
        this.path = props.path || '/';
        this.domain = props.domain || 'ithillel.ua';
    }

    _getStorage() {
        let storage = costorage.get(this.name);

        if (storage) {
            return JSON.parse(storage);
        }

        costorage.set(this.name, JSON.stringify({}), {
            expires: this.expires,
            path: this.path,
            domain: this.domain
        });
        return {};
    }

    get(key) {
        return this._getStorage()[key];
    }

    set(key, value) {
        let storage = this._getStorage();
        Object.assign(storage, { [key]: value });
        costorage.set(this.name, JSON.stringify(storage), {
            expires: this.expires,
            path: this.path,
            domain: this.domain
        });
    }

    batchSet(data) {
        if (!data || typeof data !== 'object') {
            return;
        }

        let storage = this._getStorage();
        Object.assign(storage, data);
        costorage.set(this.name, JSON.stringify(storage), {
            expires: this.expires,
            path: this.path,
            domain: this.domain
        });
    }

    delete(key) {
        let storage = this._getStorage();
        delete storage[key];
        costorage.set(this.name, JSON.stringify(storage), {
            expires: this.expires,
            path: this.path,
            domain: this.domain
        });
    }
}